import {Modal} from "@/components/common";
import BrokerCertificateListItem from "@/components/organisms/brokerCertificateListItem/BrokerCertificateListItem";

interface IProps {
  modalOpen: boolean;
  setModalOpen: (modalOpen: boolean) => void;
}

const BrokerCertificate = (props: IProps) => {
  const {modalOpen, setModalOpen} = props

  const lists = [
    {
      name: 'item1',
      id: 0
    },
    {
      name: 'item2',
      id: 1
    }
  ]

  return (
    <>
      {
        modalOpen &&
          <Modal setModalOpen={setModalOpen} position='bottom'>
            {
              lists.map((item) => {
                return <BrokerCertificateListItem key={item.id} {...item} />

              })
            }
          </Modal>
      }
    </>
  )
}

export default BrokerCertificate;